import { SelectField } from "@/ui";

export interface PostalPlace {
  city?: string;
  locality: string;
  district: string;
  state: string;
  pincode: string;
}

const keyFor = (place: PostalPlace) => JSON.stringify([place.pincode, place.district, place.state, place.locality]);

/** Every returned match is selectable; PIN, district and state distinguish similar names. */
export function PostalPlaceSelect({ matches, value, onSelect, label = "Post office / PIN", placeholder }: {
  matches: PostalPlace[];
  value: { state: string; pincode: string; district?: string; village?: string };
  onSelect: (place: PostalPlace) => void;
  label?: string;
  placeholder?: string;
}) {
  const selected = matches.find((place) => place.pincode === value.pincode && place.state === value.state
    && (value.village === undefined || place.locality === value.village)
    && (value.district === undefined || place.district === value.district));
  return <SelectField label={label} value={selected ? keyFor(selected) : ""}
    placeholder={placeholder ?? `${matches.length} matching places — choose one`}
    options={matches.map((place) => ({ value: keyFor(place), label: `${place.pincode} — ${place.district} — ${place.state} · ${place.locality}` }))}
    onChange={(event) => {
      const match = matches.find((place) => keyFor(place) === event.target.value);
      if (match) onSelect(match);
    }} />;
}
